module.exports = __webpack_public_path__ + "img/icon_lightning.3abd8244.png";